const Loader = () => {
	return (
		<div className="loader">
			<div className="loader-outer-circle">
				<div className="loader-inner-circle"></div>
			</div>
		</div>
	);
};

export default Loader;
